import OrganisationDocuments from "./organisationDocuments"
import { Consumer, Provider, OrganisationDocumentsContext } from "./organisationDocuments.context"

export { Consumer, Provider, OrganisationDocumentsContext }
export { default as OrganisationDocumentsPanel } from "./organisationDocuments.panel"
export default OrganisationDocuments
